<template>
  <div id="SubletInProcessReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area" >
       <template v-if="cantAccessPage === true">
          <div class="page-name">
            <div class="page-title">Sublet In Process</div>
            <div class="web-action-btn btn-groups text-right">
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
          </div>
          <div class="container-fluid">
            <div class="admin-page-content contact-list">
               <data-table-filter-config :moduleName="'SubletInProcessReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                <div class="data-table bg-white overflow-hidden">
                    <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                    <section class="bg-white data-table">
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange" :moduleName="'SubletInProcessReport'" :position="'top'">
                        </custom-pagination>

                        <vue-good-table
                            ref="subletInProcessTable"
                            mode="remote"
                            title="Sublet In Process"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            :totalRows="totalRecords"
                            :columns="userColumns"
                            :rows="rows"
                            :isLoading=false
                            :paginationOptions="{
                                enabled: false,
                                position: 'both',
                                perPage: perPage,
                                dropdownAllowAll: false,
                                setCurrentPage:listCurrentPage,
                                perPageDropdown:dropDownPerPage,
                            }"
                            :search-options="{
                            enabled: false,
                            }"
                            :sort-options="{
                            enabled: true,
                            }">
                        </vue-good-table>
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange">
                        </custom-pagination>
                    </section>
                </div>

            </div>
          </div>
       </template>
       <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
  name: "SubletInProcessReport",
  metaInfo() {
    return {title: "Sublet In Process - Core | " +process.env.COPYRIGHT_NAME}
  },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
      cantAccessPage:"",
      loading: false,
      pageTitle:'Sublet In Process',
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
          {
            label: "WO Number",
            field: "work_order_no",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "WO Status",
            field: "work_order_status",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            width: '90px',
        },
        {
            label: "SIP Amount",
            field: "amount",
            fpFieldType:"integer",
            type: 'number',
            filterable: true,
            hidden:false,
        },

        {
            label: "AP Amount",
            field: "ap_amount",
            filterable: true,
            fpFieldType:"integer",
            type: 'number',
            hidden:false,
        },
        {
            label: "Approved Amount",
            field: "approved_amount",
            filterable: true,
            fpFieldType:"integer",
            type: 'number',
            hidden:false,
            width: '90px',
        },
        {
            label: "Adjusted Amount",
            field: "adjust_amount",
            filterable: false,
            fpFieldType:"integer",
            type: 'number',
            hidden:false,
            sortable:false
        },
        {
            label: "Outstanding",
            field: "outstanding",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Outstanding", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: ['Yes(Y)', 'No(N)'],
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "WO Open Date",
            field: "open_date",
            filterable: true,
            fpFieldType:"date",
            hidden:false,
        },
        {
            label: "WO Close Date",
            field: "close_date",
            filterable: true,
            fpFieldType:"date",
            hidden:false,
        },
        {
            label: "WO Approved Date",
            field: "approval_date",
            filterable: true,
            fpFieldType:"date",
            hidden:false,
        },

        {
            label: "WO Facility",
            field: "location",
            fpFieldType:"option",
            filterable: true,
            hidden:false,
        },
        {
            label: "WO Unit",
            field: "unit_no",
            fpFieldType:"text",
            filterable: true,
            hidden:false,
        },
        {
            label: "TP Number",
            field: "po_number",
            fpFieldType:"text",
            filterable: true,
            hidden:false,
        },
        {
            label: "TP Receipt Sts",
            field: "po_status",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            width: '90px',
            filterOptions:{
              filterDropdownItems:['Closed','Hold','Open','Partial','Reserved','Sent','Processed','Cancelled']
            }
        },
        {
            label: "SIP Filter Balance",
            field: "filter_balance",
            fpFieldType:"integer",
            type: 'number',
            filterable: true,
            hidden:false,
            sortable:false
        },
        {
            label: "Vendor Name",
            field: "vendor",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Vendor Number",
            field: "vendor_code",
            filterable: true,
            fpFieldType:"text",
            hidden:false,

        },
        {
          label: 'Period End Date',
          field: 'period_end',
          fpFieldType:"date",
          filterable: false,
          sortable:false,
          fpMandatory:true,
          hidden:true,
      },
      ],
      action:'list',
      batchProcess:0,
      batchNum:"",

  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'sublet_in_process_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  created: function() {
      this.serverParams.stopRequest = true;
  },
  methods:{
    cancelAll: function (cancelAll) {
        this.$refs.subDayPeriodTable.unselectAllInternal();
    },
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){


      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();
      $.ajax({
        url: process.env.ROOT_API + "/sublet-in-process/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {
            if ( self.action == "export" ||  self.action == "export_queue") {
                if ( data.code == "201" ) {
                    alert(data.message);
                } else {
                    if ( self.action == "export" ) {
                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    } else {
                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }
                }
                self.action = "list";
                // self.loadList();

            } else {
               if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }


          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'reservation-list-booking')
        }
      });

    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/SubletInProcessReport.vue